import {NgModule} from "@angular/core";
import {CommonModule as NgCommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import {AddContractComponent} from "./components/modal/modal-add-contract-content/modal-add-contract-content.component";
import {DynamicFieldComponent} from "./components/dynamic-field/dynamic-field.component";
import {GoToTopComponent} from "./components/go-top/go-top.component";
import {LoadingScreenComponent} from "./components/loading-screen/loading-screen.component";
import {ModalAuthComponent} from "./components/modal/modal-auth/modal-auth.component";
import {ModalPaymentWrapperComponent} from "./components/modal/modal-wrapper/modal-wrapper.component";
import {ModalOperatorReconfirmNumberComponent} from "./components/modal/modal-operator-reconfirm-number/modal-operator-reconfirm-number.component";
import {NoClientFoundComponent} from "./components/no-client-found/no-client-found.component";
import {ToastrComponent} from "./components/toastr/toastr.component";
import {DisableControlDirective} from "./directives/disabled-directive";
import {OnlyNumbersDirective} from "./directives/only-numbers.directive";
import {PreventEnter} from "./directives/prevent-enter.directive";
import {StopPropagation} from "./directives/stop-propagation.directive";
import {FooterComponent} from "./layout/footer/footer.component";
import {MobileNavComponent} from "./layout/nav/mobile/mobile-nav.component";
import {NavComponent} from "./layout/nav/nav.component";
import { SidebarComponent } from "./layout/nav/sidebar/sidebar.component";
import {FormatComma} from "./pipes/format-comma.pipe";
import {SearchTipComponent} from "./components/search-tip/search-tip.component";
import { CodeInputModule } from 'angular-code-input';
import { EmptyData } from "./components/empty-data/empty-data.component";
import { PersonalRegisterComponent } from "../modules/register/personal-register.component";
import { BusinessRegisterComponent } from "../modules/register/business-register.component";
import { VerifyAccount } from "./components/verify-account/verify-account.component";
import { ModalCountrySelector } from "../common/components/modal/modal-country-selector/modal-country-selector.component"

@NgModule({
    imports: [
      RouterModule, 
      NgCommonModule, 
      FormsModule, 
      ReactiveFormsModule, 
      CodeInputModule.forRoot({
        codeLength: 6,
        code: ""
      }),
      TranslateModule
    ],
    providers: [TranslatePipe],
    declarations: [
        NavComponent,
        MobileNavComponent,
        SidebarComponent,
        FooterComponent,
        ModalAuthComponent,
        ModalPaymentWrapperComponent,
        ToastrComponent,
        PreventEnter,
        OnlyNumbersDirective,
        DisableControlDirective,
        StopPropagation,
        DynamicFieldComponent,
        LoadingScreenComponent,
        AddContractComponent,
        FormatComma,
        GoToTopComponent,
        NoClientFoundComponent,
        ModalOperatorReconfirmNumberComponent,
        SearchTipComponent,
        EmptyData,
        PersonalRegisterComponent,
        BusinessRegisterComponent,
        ModalCountrySelector,
        VerifyAccount
    ],
    exports: [
        NavComponent,
        MobileNavComponent,
        SidebarComponent,
        FooterComponent,
        ModalAuthComponent,
        ModalPaymentWrapperComponent,
        ToastrComponent,
        PreventEnter,
        OnlyNumbersDirective,
        DisableControlDirective,
        StopPropagation,
        DynamicFieldComponent,
        LoadingScreenComponent,
        AddContractComponent,
        FormatComma,
        GoToTopComponent,
        NoClientFoundComponent,
        ModalOperatorReconfirmNumberComponent,
        SearchTipComponent,
        EmptyData,
        TranslateModule,
        PersonalRegisterComponent,
        BusinessRegisterComponent,
        ModalCountrySelector,
        VerifyAccount
    ]
})
export class CommonModule {
}
